import AxiosMockAdapter from 'axios-mock-adapter';
import axios from 'axios';
// import axios from './axios';
import { configure } from 'axios-hooks';

let instance = axios.create({
  baseURL: 'http://localhost:8080/openempi-manager/',
  timeout: 10000
});
// export const useAxios = makeUseAxios({
//   axios: instance
// });

instance = new AxiosMockAdapter(
  axios.create({
    timeout: 10000
  }),
  { delayResponse: 3000 }
);

configure({ axios: instance });

export default instance;
